export default __webpack_public_path__ + "static/media/logoDLG.0857b9ce.png";